import type { CapacityValues } from '../../../types/components/filter_bar_types';
import { Space } from '../../../types/models/space_types';

export const checkGroupSize = (
  space: Partial<Space>,
  capacityValues: CapacityValues,
) => {
  if (!space) {
    return false;
  }
  const largestImaginableCapacity = 100_000;
  const { minGuests, maxGuests, allowSeated, allowStanding } = capacityValues;
  const { seated: seatedCapacity, standing: standingCapacity } = space;
  const presumedMinGuests = minGuests || 0;
  const presumedMaxGuests = maxGuests || largestImaginableCapacity;
  const presumedSeatedCapacity = seatedCapacity || 0;
  const presumedStandingCapacity = standingCapacity || 0;
  const seatedOrStanding = allowSeated === allowStanding;
  let seatedOk = false;
  let standingOk = false;

  if (seatedOrStanding && !minGuests && !maxGuests) {
    return true;
  }

  if (seatedOrStanding) {
    seatedOk = checkGroupSizeFits({
      capacity: presumedSeatedCapacity,
      min: presumedMinGuests,
      max: presumedMaxGuests,
    });
    standingOk = checkGroupSizeFits({
      capacity: presumedStandingCapacity,
      min: presumedMinGuests,
      max: presumedMaxGuests,
    });
  } else if (allowStanding) {
    standingOk = checkGroupSizeFits({
      capacity: presumedStandingCapacity,
      min: presumedMinGuests,
      max: presumedMaxGuests,
    });
  } else if (allowSeated) {
    seatedOk = checkGroupSizeFits({
      capacity: presumedSeatedCapacity,
      min: presumedMinGuests,
      max: presumedMaxGuests,
    });
  }

  return seatedOk || standingOk;
};

const checkGroupSizeFits = ({
  capacity,
  min,
  max,
}: {
  capacity: number;
  min: number;
  max: number;
}) => {
  if (capacity && max && min) {
    return capacity <= max && capacity >= min;
  } else if (capacity && max) {
    return capacity <= max;
  } else if (capacity && min) {
    return capacity >= min;
  } else if (!capacity && !max && !min) {
    return true;
  } else {
    return false;
  }
};
